<template>
  <div class="tab-content d-flex justify-space-between align-start">
    <div class="tab-content-text d-flex flex-column ga-8">
      <div class="d-flex flex-column">
        <h2 class="mb-3 title-medium">Links úteis</h2>
        <p class="text-start mb-6 body-medium">Esses links serão usados para direcionar o usuário de acordo com suas necessidades.
          <b>O assistente não irá utilizar as informações que são contidas no link.</b>
        </p>
        <div class="d-flex flex-column ga-4">
          <MultivaluedInput v-model="localData.referencesLinks" :input-count="2" :icons="['', 'mdi-web']"
          :label="['Descrição', 'URL']" add-text="Adicionar link" :disposition="[1.5, 3]"
            :specific-rules="{ 1: inputRules.validUrl }" :custom-error-conditions="{0: inputRules.linkDescription, 1: inputRules.linkUrl}" 
            :custom-error-messages="{0: 'Informe a descrição do link.', 1: 'Informe a URL do link.' }">
          </MultivaluedInput>
        </div>
      </div>
      <div class="d-flex flex-column ga-2 position-relative">
        <rb-loader v-model="localData.uploading_status" contained generic text="Processando documentos." />
        <v-btn v-if="localData.uploading_status" v-tooltip="'Cancelar envio.'" class="d-flex position-absolute stop-uploading-btn" @click="cancelUploadPopUp = true" icon density="compact" size="default" variant="text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2 class="title-medium">Conhecimentos adicionais</h2>
        <p class="body-medium">Documentos com regras institucionais como: dúvidas frequentes, orientações ao cliente,
          regras para submissão e afins com o objetivo de ensinar o assistente sobre regras e informações específicas.
          <b>O assistente irá utilizar as informações que são contidas no documento.</b>
        </p>
        <div class="d-flex flex-column ga-4">
          <DocumentSelector v-model="localData.referencesArchives"></DocumentSelector>
        </div>
      </div>
    </div>
    <CardBaseConhecimentos :relatedLinks="relatedLinks"></CardBaseConhecimentos>
  </div>
  <rb-popup v-model="cancelUploadPopUp" @confirm="cancelUpload" confirm-text="Cancelar envio" confirm-color="error-40">
      <template #title>
          Cancelar upload
      </template>
      <template #message>
          Tem certeza que deseja cancelar? Os arquivos não serão enviados.
      </template>
  </rb-popup>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue';
import { request } from '@/ai_studio/utils/fetchData';
import MultivaluedInput from '@/ai_studio/components/common/MultivaluedInput.vue';
import DocumentSelector from '@/ai_studio/components/common/DocumentSelector.vue';
import RbLoader from '@/ai_studio/components/common/RbLoader.vue';
import CardBaseConhecimentos from '@/assistents/components/CardBaseConhecimentos.vue';
import RbPopup from '@/ai_studio/components/common/RBPopup.vue';
const emit = defineEmits(['update:modelValue']);
const cancelUploadPopUp = ref(false);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  relatedLinks: {
    type: Array,
    required: true
  },
  inputRules: {
    type: Object,
    required: true
  }
});

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue);
  }
});

const cancelUpload = async () => {
  try {
    await request(`/api/assistents/cancel-uploads?key=${localData.value.assistentKey}`, { success: 'Envio cancelado com sucesso.', error: 'Erro ao atualizar o status de upload.' });
    localData.value.uploading_status = false;
  } catch (err) {
    console.error(err);
  }
}
</script>

<style lang="scss" scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss';
.stop-uploading-btn{
	z-index: 99999;
	left: 100%;
}
</style>